import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const SearchSchema = withDefaults({
  type: 'search',
  fields: [
    {
      kind: 'attribute',
      name: 'items',
    },
    {
      kind: 'attribute',
      name: 'total',
    },
    {
      kind: 'attribute',
      name: 'took',
    },
  ],
});

export default SearchSchema;
